import type { CourseListResponseCoursesItem } from './courseListResponseCoursesItem';
import type { CourseListResponsePagination } from './courseListResponsePagination';

export interface CourseListResponse {
  /** 조회된 강의 목록 */
  courses: CourseListResponseCoursesItem[];
  /** 페이지네이션 정보 (Spring Data Page 스타일) */
  pagination: CourseListResponsePagination;
}
